import { useMediaQuery, useTheme } from "@mui/material";
import DashboardDataDesktop from "../components/desktop/data-dashboard-report/DashboardDataDesktop";
import DashboardDataMobile from "../components/mobile/data-dashboard-report/DataDashboardMobile";

const DataDashboardReport = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return <>{isMobile ? <DashboardDataMobile /> : <DashboardDataDesktop />}</>;
};
export default DataDashboardReport;
